<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <v-form ref="create_promotion" @submit.prevent="save_data">
          <div class="grid_half">
            <div class="pa-2">
              <div class="mt-4">
                <v-img height="200" max-width="200" v-if="imagePreviewURL == null" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                <v-img height="200" max-width="200" v-if="imagePreviewURL != null" :src="imagePreviewURL" class="preview mx-auto"></v-img>
              </div>
              <div class="ml-3 mr-3">
                <v-file-input color="#86bc3a" accept="image/*" label="รูปภาพสินค้า" prepend-icon="mdi-camera" hide-details="auto" v-model="pro_pic_name" @change="onFileChange"></v-file-input>
              </div>
            </div>
            <div class="pa-2">
              <div class="grid_list">
                <div class="ml-3 mt-6 mr-3">
                  <v-text-field color="#86bc3a" label="ชื่อโปรโมชั่น" hide-details="auto" v-model="send_data.promotion_name" :rules="[v => !!v || 'กรุณากรอกชื่อโปรโมชั่น']" required outlined></v-text-field>
                </div>
                <div class="ml-3 mt-6 mr-3">
                  <v-text-field color="#86bc3a" type="number" label="ราคาขาย(ต่อชุด)" min="0" @keypress="onlyNumber($event, send_data.price_per_set)" v-model="send_data.price_per_set" :rules="[v => !!v || 'กรุณากรอกราคาขาย(ต่อชุด)']" hide-details="auto" required outlined></v-text-field>
                </div>
                <div class="ml-3 mt-6 mr-3">
                  <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field color="#86bc3a" v-model="date" label="วันที่สิ้นสุดโปรโมชั่น (วัน/เดือน/ปี)" :rules="[v => !!v || 'กรุณาระบุวันที่สิ้นสุดโปรโมชั่น']" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" required outlined></v-text-field>
                    </template>
                    <v-date-picker locale="TH" color="#86bc3a" @change="diffDate_TH(dateEN)" v-model="dateEN" :min="start_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="selectDate()">
                        ตกลง
                      </v-btn>
                      <v-btn text color="primary" @click="menu_date = false">
                        ยกเลิก
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="ml-3 mt-6 mr-3">
                  <v-text-field color="#86bc3a" type="number" label="จำนวนชุดจัดโปรโมชั่น" @keypress="isNumber($event)" v-model="send_data.number_set" min="0" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกจำนวนชุดจัดโปรโมชั่น']" required outlined></v-text-field>
                </div>
<!--                <div class="d-none">-->
<!--                  <div>{{  send_data.number_set = set_grand }}</div>-->
<!--                  <div>{{ value_set = set_grand }}</div>-->
<!--                </div>-->
                <div class="ml-3 mr-3">
                  <v-select color="#86bc3a" :items="promotion_list" item-text="show_promotion_name" item-value="show_promotion_id" :rules="[v => !!v || 'กรุณาเลือกสถานะแสดงการขาย']" v-model="send_data.show_promotion" label="สถานะแสดงการขาย" hide-details="auto" required outlined/>
                </div>
              </div>
              <div class="grid_full">
                <div class="ml-3 mt-6 mr-3">
                  <v-textarea color="#86bc3a" label="รายละเอียดโปรโมชั่น" hide-details="auto" v-model="send_data.promotion_note" outlined></v-textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="pa-2">
            <v-card-title>
              <div>
                สินค้าในชุด
              </div>
            </v-card-title>
            <div v-if="loading_input === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <v-card-title v-else>
              <v-autocomplete clearable @input="addProductList()" color="#86bc3a" :items="product_list" item-text="product_name" item-value="product_id" v-model="send_data.pro_id" prepend-inner-icon="mdi-cart-outline" label="สินค้า" hide-details="auto" outlined/>
            </v-card-title>
            <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0" hide-default-footer>
              <template slot="item" slot-scope="dataDetail">
                <tr>
                  <td>{{ dataDetail.item.product_name }}</td>
                  <td v-if="dataDetail.item.lot_no !== ''">{{ dataDetail.item.lot_no }} <v-icon color="orange" class="ma-1" @click="get_lots(dataDetail.item.product_id, dataDetail.item.loop_id)">mdi-pencil</v-icon></td>
                  <td v-if="dataDetail.item.lot_no === ''">
                    <a @click="get_lots(dataDetail.item.product_id, dataDetail.item.loop_id)" class="pa-3" >เลือกล็อตสินค้า</a>
                  </td>
                  <td>{{ dataDetail.item.date_expired }}</td>
                  <td>{{ format_number(dataDetail.item.quantity) }}</td>
                  <td>{{ format_price(dataDetail.item.cost) }}</td>
                  <td>
                    <v-text-field type="number"  @paste="isPaste($event)"  class="width" color="#86bc3a"  v-model.number="dataDetail.item.total_set"  append-outer-icon="mdi-plus"
                                   @click:append-outer="increment(dataDetail.item.loop_id, dataDetail.item.total_set, dataDetail.item.quantity)" prepend-icon="mdi-minus" @click:prepend="decrement(dataDetail.item.loop_id, dataDetail.item.total_set, dataDetail.item.quantity)">
                    </v-text-field>
                  </td>
                  <td class="pa-3">
                    <v-btn small height="42" @click="deleteProduct(dataDetail.item.loop_id, dataDetail.item.product_id)" class="grad-danger-bg white--text mb-1">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-slot:body.append>
                <tr>
                  <td colspan="3" class="text-center">รวมราคาต้นทุนต่อชุด</td>
                  <td>{{ send_data.total_quantity = format_number(total_quantity) }}</td>
                  <td>{{ send_data.total_grand = format_price(total_cost) }}</td>
                  <td class="text-center">{{ send_data.total_set = increment_number }}</td>
                  <td></td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <div class="text-center mt-4 pb-4">
            <v-btn height="45" class="white--text grad-success-bg btn_size" type="submit">บันทึกข้อมูล</v-btn>
          </div>
        </v-form>
        <v-dialog v-model="modal_lots" max-width="900">
          <div v-if="loading_modal === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-card>
              <div class="d-flex justify-space-between">
                <v-card-title>
                  กรุณาเลือกล็อตสินค้าที่ต้องการจัดโปรโมชั่น
                </v-card-title>
                <v-btn icon class="ma-4" @click="modal_lots = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-divider/>
              <div class="pa-2">
                <v-card-title>
                  <v-text-field color="#86bc3a" v-model="search_lots" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers_lots" :items="datalist_lots" :footer-props="footer_Props" :search="search_lots" mobile-breakpoint="0">
                  <template v-slot:item="dataDetail" class="grid_btn">
                    <tr>
                      <td>{{ dataDetail.item.lot_no }}</td>
                      <td>{{ format_number(dataDetail.item.quantity) }}</td>
                      <td>{{ dataDetail.item.date_expired }}</td>
                      <td>{{ format_price(dataDetail.item.cost) }}</td>
                      <td>
                        <div>
                          <v-btn class="pa-6 ma-2 grad-success-bg white--text" @click="prepare_lots(dataDetail.item.product_id, dataDetail.item.lot_no, dataDetail.item.date_expired, dataDetail.item.cost, dataDetail.item.import_id, dataDetail.item.po_id, dataDetail.item.unit_id, dataDetail.item.quantity)">เลือกล็อต</v-btn>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-card>
          </div>
        </v-dialog>
      </v-card>
    </div>
  </div>
</template>

<script src="@/previewimage.js"></script>
<script>
import img_holder from "@/assets/pharmacy.png";
import {
  diffChangeFormat, diffDateEN_Change,
  diffDateTH,
  formatNumber,
  formatPrice,
  minDate,
  onlyForCurrency,
  onlyForNumber,
  onPaste
} from "@/js/handler";
import {HTTP} from "@/axios";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_add",
  data() {
    return {
      a: null,
      img_holder: img_holder,
      pro_pic_name: null,
      imagePreviewURL: null,
      loading_page: false,
      loading_input: false,
      loading_modal: false,
      search: null,
      search_lots: null,
      alert_success: false,
      alert_danger: false,
      menu_date: false,
      date: '',
      dateEN: '',
      start_date: this.min_date(),
      value_set: null,
      loop_id: 0,
      get_loop: null,
      get_loop_edit: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      promotion_list: [
        {
          show_promotion_id: 1,
          show_promotion_name: 'แสดงทั้งขายปลีก , ขายส่ง',
        },
        {
          show_promotion_id: 2,
          show_promotion_name: 'แสดงเฉพาะขายปลีก',
        },
        {
          show_promotion_id: 3,
          show_promotion_name: 'แสดงเฉพาะขายส่ง',
        },
      ],
      send_data: {
        promotion_name: '',
        price_per_set: '',
        number_set: 0,
        promotion_note: '-',
        pro_id: null,
        total_grand: 0,
        total_set: 0,
        total_quantity: 0,
        grand_set: 0,
        show_promotion: null,
      },
      selected: null,
      selected_arr: [],
      modal_lots: false,
      modal_lots_update: false,
      headers: [
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'ล็อตสินค้า',
          value: 'lot_no',
          fixed: true,
          width: '180px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'expired_date',
          fixed: true,
          width: '150px',
        },
        {
          text: 'คงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคาต้นทุน',
          value: 'cost',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวนในชุด',
          value: 'total_set',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ลบ',
          value: '',
          sortable: false,
          fixed: true,
          width: '100px',
        },
      ],
      data_list: [],
      headers_lots: [
        {
          text: 'รหัสล็อต',
          value: 'lot_no',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคาต้นทุน',
          value: 'cost',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '100px',
        },
      ],
      datalist_lots: [],
      product_list: [],
    }
  },
  methods: {
    format_price: function(value) {
      return formatPrice(value)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    isNumber: function(evt) {
      return onlyForNumber(evt)
    },
    onlyNumber: function(evt, number) {
      return onlyForCurrency(evt, number)
    },
    min_date: function() {
      return minDate()
    },
    diffTH: function(value) {
      return diffDateTH(value)
    },
    diffChange: function (value) {
      return diffChangeFormat(value)
    },
    diffEN_Change: function (value) {
      return diffDateEN_Change(value)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.pro_pic_name = null
          })
        } else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL = null
            this.pro_pic_name = null
          }
        }
      } else {
        this.imagePreviewURL = null
        this.pro_pic_name = null
      }
    },
    diffDate_TH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const total_date = day+'-'+month+'-'+year
      return this.date = total_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    get_product() {
      this.loading_page = true
      HTTP.post('/inventory/getmain')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.product_list = res.data.object
              const pro_id = this.product_list.map((detail) => {
                return detail.product_id
              })
              this.selected_arr = pro_id
            }
          })
    },
    get_product_main() {
      this.product_list = []
      HTTP.post('/inventory/getmain')
          .then((res) => {
            if (res.data.success === true) {
              res.data.object.forEach((data) => {
                let inc = this.selected_arr.includes(data.product_id)
                if (inc === true) {
                  this.product_list.push(data)
                }
              })
            }
          })
    },
    async addProductList() {
      const value = this.product_list.filter((details) => {
        return details.product_id === this.send_data.pro_id
      })
      value.forEach((data) => {
        const loop_id = this.loop_id +=1
        this.data_list.push({
          loop_id: loop_id,
          import_id: null,
          po_id: null,
          unit_id: null,
          product_id: data.product_id,
          product_code: data.product_code,
          product_name: data.product_name,
          product_status: data.product_status,
          quantity: null,
          lot_no: '',
          expired_date: '',
          cost: null,
          total_set: 0,
          set_quantity: 0,
        })
      })
      const find_product = this.data_list.filter(data => data.product_id === this.send_data.pro_id)
      const map_product = find_product.map(data => data.product_id)
      const pop_id = map_product.pop()
      const index = this.selected_arr.indexOf(pop_id);
      if (index > -1) {
        this.selected_arr.splice(index, 1);
      }
      this.get_product_main()
      await this.$nextTick(() => {
        this.send_data.pro_id = null;
      })
      this.alert_success = true;
      setTimeout(() => this.alert_success = false, 1000);
    },
    deleteProduct(loop_id, product_id) {
      this.selected_arr.push(product_id)
      this.data_list = this.data_list.filter(detail => detail.loop_id !== loop_id)
      this.get_product_main()
      this.send_data.pro_id = null;
      this.alert_danger = true;
      setTimeout(() => this.alert_danger = false, 1000);
    },
    
    increment(key, number, quantity) {
      let qty = parseInt(quantity)
      this.data_list.forEach((data) => {
        if (key === data.loop_id) {
          if (data.total_set >= 0 && data.total_set !== '' && data.total_set !== null && data.total_set !== 'NaN') {
            if (data.total_set < qty) {
              data.set_quantity = Math.floor((qty / (data.total_set + 1)))
              data.total_set = parseInt(number, 10) + 1
              this.set_grand()
            }
          }
          else {
            data.set_quantity = 0
            data.total_set = 1
          }
        }
      })
    },
    decrement(key, number, quantity) {
      let qty = parseInt(quantity)
      this.data_list.forEach((data) => {
        if (key === data.loop_id) {
          if ((data.total_set <= 0 || data.total_set === '' || data.total_set === null) || number === 'NaN') {
            data.total_set = 0
            data.set_quantity = 0
            this.send_data.number_set = 0
          }
          else {
            if (data.total_set <= qty) {
              data.set_quantity = Math.floor((qty / (data.total_set - 1)))
              data.total_set = parseInt(number, 10) - 1
              this.set_grand()
            }
          }
        }
      })
    },
    set_grand() {
      this.send_data.number_set = 0
      this.value_set = 0
      this.data_list.map((data) => {return data.set_quantity})
      let quantity_set = [... new Set(this.data_list.map(data => data.set_quantity))]
      let min_quantity_set = Math.min(...quantity_set)
      this.value_set = min_quantity_set
      this.send_data.number_set = min_quantity_set
    },
    get_lots(product_id, loop_id) {
      this.get_loop = loop_id
      this.modal_lots = true
      this.loading_modal = true
      HTTP.post('/inventory/promotions/mains/getlots', {
        product_id: product_id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_modal = false
          this.datalist_lots = res.data.object
        }
      })
    },
    prepare_lots(product_id, lot_no, date_expired, cost, import_id, po_id, unit_id, quantity) {
      const key = this.get_loop
      this.data_list.forEach((data) => {
        if (key === data.loop_id) {
          data.lot_no = lot_no
          data.date_expired = date_expired
          data.quantity = parseInt(quantity)
          data.cost = parseFloat(cost)
          data.import_id = parseInt(import_id)
          data.po_id = parseInt(po_id)
          data.unit_id = parseInt(unit_id)
        }
      })
      this.modal_lots = false
    },
    save_data() {
      if (this.data_list.length > 0 && this.send_data.total_grand !== '0') {
        if (this.pro_pic_name !== '' && this.pro_pic_name !== null) {
          if (this.send_data.number_set <= this.value_set) {
            if (this.send_data.number_set !== 0 || this.send_data.number_set !== '' || this.send_data.number_set !== '0') {
              let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
              let file = this.pro_pic_name.name;
              let ext = file.split('.').pop().toLowerCase();
              if (parseInt(extall.indexOf(ext)) < 0) {
                Swal.fire({
                  text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
                  icon: 'error',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                }).then(() => {
                  this.imagePreviewURL = null
                  this.pro_pic_name = null
                })
              }
              else {
                if (this.$refs.create_promotion.validate()) {
                  Swal.fire({
                    text: 'ต้องการบันทึกข้อมูลหรือไม่ ?',
                    icon: 'warning',
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: `ตกลง`,
                    denyButtonText: `ยกเลิก`,
                  }).then((res) => {
                    if (res.isConfirmed === true) {
                      let config = {
                        headers: {
                          'Content-Type': 'multipart/form-data'
                        }
                      }
                      let formData = new FormData()
                      formData.append('user_id', this.$store.state.userDetail.id)
                      formData.append('user_name', this.$store.state.userDetail.name)
                      formData.append('promotion_image', this.pro_pic_name, this.pro_pic_name.name)
                      formData.append('promotion_name', this.send_data.promotion_name)
                      formData.append('price_per_set', this.send_data.price_per_set)
                      formData.append('end_date', this.diffDateEN())
                      formData.append('number_set', this.send_data.number_set)
                      formData.append('total_grand', this.send_data.total_grand)
                      formData.append('note', this.send_data.promotion_note)
                      formData.append('total_set', this.send_data.total_set)
                      formData.append('show_promotion', this.send_data.show_promotion)
                      formData.append('data_list', JSON.stringify(this.data_list))
                      HTTP.post('/inventory/promotions/mains/create', formData, config)
                          .then((res) => {
                            if (res.data.success === true) {
                              Swal.fire({
                                text: 'บันทึกข้อมูลเรียบร้อย !',
                                icon: 'success',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: `ตกลง`,
                                denyButtonText: `ยกเลิก`,
                              }).then((res) => {
                                if (res.isConfirmed === true) {
                                  this.$router.push('/stock/promotion_stock/promotionset')
                                }
                                else {
                                  this.$router.push('/stock/promotion_stock/promotionset')
                                }
                              })
                            }
                          })
                    }
                  })
                }
              }
            }
            else {
              Swal.fire({
                title: 'กรุณาตรวจสอบ !',
                text: 'จำนวนชุดโปรโมชั่นไม่ควรต่ำกว่า 1 ชุด',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              })
            }
          } else {
            Swal.fire({
              title: 'จำนวนชุดโปรโมชั่นเกินกว่าที่กำหนด !',
              text: 'จำนวนสูงสุดที่จัดชุดโปรโมชั่นได้คือ ' + this.value_set,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        }
        else {
          if (this.$refs.create_promotion.validate()) {
            if (this.send_data.number_set !== 0 || this.send_data.number_set !== '' || this.send_data.number_set !== '0') {
              Swal.fire({
                title: 'กรุณาตรวจสอบ !',
                text: 'ต้องการบันทึกข้อมูลหรือไม่ ?',
                icon: 'warning',
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then((res) => {
                if (res.isConfirmed === true) {
                  let config = {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                  }
                  let formData = new FormData()
                  formData.append('user_id', this.$store.state.userDetail.id)
                  formData.append('user_name', this.$store.state.userDetail.name)
                  formData.append('promotion_name', this.send_data.promotion_name)
                  formData.append('price_per_set', this.send_data.price_per_set)
                  formData.append('end_date', this.diffDateEN())
                  formData.append('note', this.send_data.promotion_note)
                  formData.append('number_set', this.send_data.number_set)
                  formData.append('total_grand', this.send_data.total_grand)
                  formData.append('total_set', this.send_data.total_set)
                  formData.append('show_promotion', this.send_data.show_promotion)
                  formData.append('data_list', JSON.stringify(this.data_list))
                  HTTP.post('/inventory/promotions/mains/create', formData, config)
                      .then((res) => {
                        if (res.data.success === true) {
                          Swal.fire({
                            text: 'บันทึกข้อมูลเรียบร้อย !',
                            icon: 'success',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: `ตกลง`,
                            denyButtonText: `ยกเลิก`,
                          }).then((res) => {
                            if (res.isConfirmed === true) {
                              this.$router.push('/stock/promotion_stock/promotionset')
                            }
                            else {
                              this.$router.push('/stock/promotion_stock/promotionset')
                            }
                          })
                        }
                      })
                }
              })
            } else {
              Swal.fire({
                title: 'กรุณาตรวจสอบ !',
                text: 'จำนวนชุดโปรโมชั่นไม่ควรต่ำกว่า 1 ชุด',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              })
            }
          }
        }
      }
      else {
        this.$refs.create_promotion.validate()
        Swal.fire({
          title: 'กรุณาตรวจสอบข้อมูล !',
          text: 'ยังไม่ได้เลือกสินค้าหรือล็อตสินค้าหรือและจำนวนในชุดเป็น 0 !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
    getEdit(product_id, loop_id) {
      this.get_loop_edit = loop_id
      this.modal_lots_update = true
      this.loading_modal = true
      HTTP.post('/inventory/promotions/mains/getlots', {
        product_id: product_id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_modal = false
          this.datalist_lots = res.data.object
        }
      })
    }
  },
  computed: {
    increment_number() {
      let data_list = this.data_list
      let total_set = 0
      data_list.forEach((data) => {
        if (data.total_set !== '' && data.total_set !== null) {
          total_set += parseInt(data.total_set)
        }
        else {
          data.total_set = 0
        }
      })
      // let result = data_list.reduce((sum, number) => {
      //   total_set = number.total_set
      //   if (total_set < 0) {
      //     return sum
      //   }
      //   else {
      //     return sum+(total_set)
      //   }
      // }, 0)
      return total_set
    },
    total_quantity() {
      this.send_data.total_quantity = 0
      let total_quantity = 0
      let data_list = this.data_list
      data_list.forEach((data) => {
        if (data.cost !== '' && data.quantity !== null) {
          total_quantity += parseInt(data.quantity)
        }
        else {
          data.quantity = 0
        }
      })
      return total_quantity
    },
    total_cost() {
      this.send_data.total_grand = 0.00
      let total_grand = 0
      let data_list = this.data_list
      data_list.forEach((data) => {
        if (data.cost !== '' && data.cost !== null) {
          total_grand += parseInt(data.cost)
        }
        else {
          data.cost = 0
        }
      })
      return total_grand
    },
  },
  watch: {
    data_list: {
      handler(newValue, oldValue) {
        newValue.forEach(item => {
          // ใช้ nextTick เพื่อรอให้ DOM อัปเดตก่อน
          this.$nextTick(() => {
            // ตรวจสอบว่า total_set เป็นตัวเลขที่ถูกต้อง
            let total_set_value = parseInt(item.total_set);
            let max_quantity = parseInt(item.quantity);

            if (isNaN(total_set_value) || total_set_value < 0) {
              item.total_set = 0;
            } else if (total_set_value > max_quantity) {
              item.total_set = max_quantity;
            }
          });
        });
        // อัปเดตค่ารวมหลังจากตรวจสอบเสร็จสิ้น
        this.set_grand();
      },
      deep: true, // watch nested properties inside data_list
      immediate: true // run on mount
    }
  },
  mounted() {
    this.get_product()
  }

}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_half {
  display: grid;
  grid-template-columns: 30% 70%;
}
.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.width >>> input {
  max-width: 100%;
  text-align: center;
}
.btn_size {
  font-size: 18px;
}
.preview {
  border-radius: 8px;
}
@media only screen and (max-width: 1100px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_full {
    display: grid;
    grid-template-columns: 100%;
    margin-top: 40px;
  }
}
</style>
